import { render, staticRenderFns } from "./ProspectsTable.vue?vue&type=template&id=2daa0830&scoped=true"
import script from "./ProspectsTable.vue?vue&type=script&lang=js"
export * from "./ProspectsTable.vue?vue&type=script&lang=js"
import style0 from "./ProspectsTable.vue?vue&type=style&index=0&id=2daa0830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa0830",
  null
  
)

export default component.exports